import { useEffect } from 'react';
import { isArr, Keys } from '@ecom-zform/shared';
export function useFormEffects(form, listeners, options) {
    var deps = isArr(form) ? form.map(function (f) { return f.uuid; }).join('/') : form.uuid;
    useEffect(function () {
        var stopList = [];
        if (isArr(form)) {
            var newListeners_1 = {};
            Keys(listeners).map(function (type) {
                var cb = listeners[type];
                newListeners_1[type] = function () {
                    if (cb) {
                        cb(form);
                    }
                };
            });
            form.forEach(function (fc) {
                stopList.push(fc.effects(newListeners_1, options));
            });
        }
        else {
            stopList.push(form.effects(listeners, options));
        }
        return function () {
            stopList.forEach(function (stop) { return stop(); });
        };
    }, [deps]);
}
